import React from "react";
import { Image } from "react-bootstrap";
import ModalWrapper from "../../../../../../components/ModalWrapper";

type Props = {
  show: boolean;
  imgPath: string;
  onHide: () => void;
  centered?: boolean;
};

const FullScreenImageModal: React.FC<Props> = ({
  show,
  imgPath,
  onHide,
  centered = true
}) => (
  <ModalWrapper
    show={show}
    onHide={onHide}
    fullscreen
    showHeader={false}
    centered={centered}
    className="rl-cloud-sandbox-modal-transparent"
  >
    <div className="rl-cloud-sandbox-fullscreen-container" onClick={onHide}>
      <Image src={imgPath} />
    </div>
  </ModalWrapper>
);

export default FullScreenImageModal;
